export const INDEX_PAGE = "/";

export const DASHBOARD_PAGE = "/dashboard";

export const API_DOCS_PAGE = "/api-docs";

export const FEATURE_REQUEST_PAGE = "/feature-requests";

export const BUGS_PAGE = "/bugs";

export const COMPANY_PAGE = "/company";

export const SETTINGS_PAGE = "/settings";

export const SHOPIFY_PAGE = "/fleetpanda-store";

export const PANDA_SCORE_PAGE = "/panda-score";

export const ORG_SETTINGS_PAGE = "/org-settings";
